import styled, { css } from "styled-components";
import { SnapCarrouselItemProps } from "./SnapCarrousel.types";
import { ThemeSpacingKeys } from "ui/config/theme/spacing";

export const SnapCarrouselRoot = styled.div<{ gap: ThemeSpacingKeys | undefined }>(
    ({ theme, gap }) => css`
        position: relative;
        white-space: normal;
        display: flex;
        padding-bottom: 5px;
        scrollbar-width: none;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        gap: ${typeof gap !== "undefined" ? theme.spacing[gap] : undefined};

        &::-webkit-scrollbar {
            display: none;
        }

        ${theme.breakpoints.down("maxPageWidth")} {
            /* Track */
            ::-webkit-scrollbar-track {
                background: unset;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
                background-color: unset;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
                background-color: unset;
            }
        }
    `,
);

export const SnapCarrouselItem = styled.div<SnapCarrouselItemProps>(
    ({ fullWidth }) => css`
        flex: ${fullWidth ? "0 0 100%" : "0 0 auto"};
        scroll-snap-align: center;
    `,
);

export const SnapCarouselPaginator = styled.div(
    () => css`
        display: flex;
        justify-content: center;
        gap: 4px;
        margin-top: 20px;
    `,
);

export const SnapCarouselPage = styled.button<{ selected?: boolean }>(
    ({ selected }) => css`
        border: none;
        padding: 0px;
        margin. 0px;
        width: 25px;
        height: 4px;
        background-color: ${selected ? "#6F7070" : "#b7b8b8"};
        cursor: pointer;
        border-radius: 10px;
    `,
);
